import { h } from 'preact';
import './LoadingSpinner.scss';

export default ({ visible }) => (visible ? <div class="loading-spinner"></div> : null);
// export default ({ visible }) => ((visible || true) ? <div class="loading-spinner"></div> : null);


// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js